import { SOCIALS } from "public/assetsV2/images";
import { TFooterProps } from "@kelp-dao/kernel-design-system";
import BaseImage from "@components/BaseImage";
import { DiscordLogoIcon, TelegramLogoIcon } from "@phosphor-icons/react";
import { trackEvent } from "utils";

export const FOOTER_CONFIG: TFooterProps = {
  sections: [
    {
      id: "products",
      title: "Product",
      links: [
        {
          id: "kelp",
          // label: "Kelp",
          href: "https://kerneldao.com/kelp/",
          isHighlighted: true,
          icon: (
            <div className="h-6 w-auto flex items-center justify-center">
              <BaseImage
                src="/assets/socials/Kelp.svg"
                alt="Kelp"
                width={24}
                height={28}
                className="object-contain w-full h-auto"
              />
            </div>
          ),
          sendEvent: () => {
            trackEvent("lp_footer_clicks", {
              event_type: "url_click",
              event_category: "Landing",
              category: "Product",
              label: "Kelp",
              destination_url: "https://kerneldao.com/kelp/",
            });
          },
        },
        {
          id: "gain",
          // label: "Gain",
          href: "https://kerneldao.com/gain/",
          isHighlighted: true,
          icon: (
            <div className="h-6 w-auto flex items-center justify-center">
              <BaseImage
                src="/assets/socials/Gain.svg"
                alt="Gain"
                className="object-contain w-full h-auto"
                width={24}
                height={32}
              />
            </div>
          ),
          sendEvent: () => {
            trackEvent("lp_footer_clicks", {
              event_type: "url_click",
              event_category: "Landing",
              category: "Product",
              label: "Gain",
              destination_url: "https://kerneldao.com/gain/",
            });
          },
        },
        {
          id: "kernel",
          // label: "Kernel",
          href: "https://kerneldao.com/kernel/",
          isHighlighted: true,
          icon: (
            <div className="h-6 w-auto flex items-center justify-center">
              <BaseImage
                src="/assets/socials/Kernel.svg"
                alt="Kernel"
                className="object-contain w-full h-auto"
                width={24}
                height={28}
              />
            </div>
          ),
          sendEvent: () => {
            trackEvent("lp_footer_clicks", {
              event_type: "url_click",
              event_category: "Landing",
              category: "Product",
              label: "Kernel",
              destination_url: "https://kerneldao.com/kernel/",
            });
          },
        },
      ],
    },
    {
      id: "governance",
      title: "Governance",
      links: [
        {
          id: "stake-kernel",
          label: "Stake $KERNEL",
          href: "https://kerneldao.com/stake/",
          sendEvent: () => {
            trackEvent("lp_footer_clicks", {
              event_type: "url_click",
              event_category: "Landing",
              category: "Governance",
              label: "Stake $KERNEL",
              destination_url: "https://kerneldao.com/stake/",
            });
          },
        },
        {
          id: "forum",
          label: "Forum",
          href: "https://forum.kerneldao.com/t/welcome-to-kerneldao-governance-forum/5",
          isExternal: true,
          sendEvent: () => {
            trackEvent("lp_footer_clicks", {
              event_type: "url_click",
              event_category: "Landing",
              category: "Governance",
              label: "Forum",
              destination_url:
                "https://forum.kerneldao.com/t/welcome-to-kerneldao-governance-forum/5",
            });
          },
        },
        {
          id: "vote",
          label: "Vote",
          href: "https://snapshot.org/#/kerneldao.eth",
          isExternal: true,
          sendEvent: () => {
            trackEvent("lp_footer_clicks", {
              event_type: "url_click",
              event_category: "Landing",
              category: "Governance",
              label: "Vote",
              destination_url: "https://snapshot.org/#/kerneldao.eth",
            });
          },
        },
      ],
    },
    {
      id: "insights",
      title: "Insights",
      links: [
        {
          id: "litepaper",
          label: "Litepaper",
          href: "https://kerneldao.gitbook.io/litepaper",
          isExternal: true,
          sendEvent: () => {
            trackEvent("lp_footer_clicks", {
              event_type: "url_click",
              event_category: "Landing",
              category: "Insights",
              label: "Litepaper",
              destination_url: "https://kerneldao.gitbook.io/litepaper",
            });
          },
        },
        {
          id: "docs",
          label: "Docs",
          href: "https://kerneldao.gitbook.io/kernel",
          isExternal: true,
          sendEvent: () => {
            trackEvent("lp_footer_clicks", {
              event_type: "url_click",
              event_category: "Landing",
              category: "Insights",
              label: "Docs",
              destination_url: "https://kerneldao.gitbook.io/docs",
            });
          },
        },
      ],
    },
    {
      id: "developers",
      title: "Developers",
      links: [
        {
          id: "brandkit",
          label: "Brandkit",
          href: "https://kerneldao.com/brand-kit/",
          isExternal: true,
          sendEvent: () => {
            trackEvent("lp_footer_clicks", {
              event_type: "url_click",
              event_category: "Landing",
              category: "Developers",
              label: "Brandkit",
              destination_url: "https://kerneldao.com/brand-kit/",
            });
          },
        },
        {
          id: "github",
          label: "Github",
          href: "https://github.com/Kelp-DAO/kernel-smart-contracts-public",
          isExternal: true,
          sendEvent: () => {
            trackEvent("lp_footer_clicks", {
              event_type: "url_click",
              event_category: "Landing",
              category: "Developers",
              label: "Github",
              destination_url:
                "https://github.com/Kelp-DAO/kernel-smart-contracts-public",
            });
          },
        },
      ],
    },
    {
      id: "blogs",
      title: "Blogs",
      href: "https://blogs.kerneldao.com/",
      isExternal: true,
      sendEvent: () => {
        trackEvent("lp_footer_clicks", {
          event_type: "url_click",
          event_category: "Landing",
          category: "Blogs",
          label: "Blogs",
          destination_url: "https://blogs.kerneldao.com/",
        });
      },
    },
    {
      id: "ecosystem",
      title: "Ecosystem",
      href: "https://kerneldao.com/ecosystem/",
      isExternal: true,
      sendEvent: () => {
        trackEvent("lp_footer_clicks", {
          event_type: "url_click",
          event_category: "Landing",
          category: "Ecosystem",
          label: "Ecosystem",
          destination_url: "https://kerneldao.com/ecosystem/",
        });
      },
    },
  ],

  socialIcons: [
    {
      id: "x-kernel",
      icon: (
        <img src={SOCIALS.XKernel.src} alt="" className="w-[50px] h-[32px]" />
      ),
      href: "https://x.com/kernel_dao",
      label: "Follow KernelDAO on X",
      sendEvent: () => {
        trackEvent("lp_social_click", {
          event_type: "button_click",
          event_category: "Landing",
          platform: "x",
          location: "footer",
          destination_url: "https://x.com/kernel_dao",
        });
      },
    },
    {
      id: "x-kelp",
      icon: (
        <img src={SOCIALS.XKelp.src} alt="" className="w-[50px] h-[32px]" />
      ),
      href: "https://x.com/KelpDAO",
      label: "Follow KelpDAO on X",
      sendEvent: () => {
        trackEvent("lp_social_click", {
          event_type: "button_click",
          event_category: "Landing",
          platform: "x",
          location: "footer",
          destination_url: "https://x.com/KelpDAO",
        });
      },
    },
    {
      id: "telegram",
      icon: <TelegramLogoIcon color="#DDEFF0" className="w-8 h-8" />,
      href: "https://t.me/KelpDAOxyz",
      label: "Join Telegram",
      sendEvent: () => {
        trackEvent("lp_social_click", {
          event_type: "button_click",
          event_category: "Landing",
          platform: "telegram",
          location: "footer",
          destination_url: "https://t.me/KelpDAOxyz",
        });
      },
    },
    {
      id: "discord",
      icon: <DiscordLogoIcon color="#DDEFF0" className="w-8 h-8" />,
      href: "https://discord.gg/khSpqCFvGq",
      label: "Join Discord",
      sendEvent: () => {
        trackEvent("lp_social_click", {
          event_type: "button_click",
          event_category: "Landing",
          platform: "discord",
          location: "footer",
          destination_url: "https://discord.gg/khSpqCFvGq",
        });
      },
    },
  ],

  policies: [
    {
      id: "privacy-policy",
      label: "Privacy Policy",
      href: "https://docs.google.com/document/d/1cEYdXEXniLWtXdjDmZH3RcMMMAffKHMstahj2OKNmUc/",
      sendEvent: () => {
        trackEvent("lp_footer_clicks", {
          event_type: "url_click",
          event_category: "Landing",
          category: "Privacy Policy",
          label: "Privacy Policy",
          destination_url:
            "https://docs.google.com/document/d/1cEYdXEXniLWtXdjDmZH3RcMMMAffKHMstahj2OKNmUc/",
        });
      },
    },
    {
      id: "terms-of-use",
      label: "Terms of Use",
      href: "https://docs.google.com/document/d/1SuXHTQVprMGLbfzICaWVENChlDE4BC8c/",
      sendEvent: () => {
        trackEvent("lp_footer_clicks", {
          event_type: "url_click",
          event_category: "Landing",
          category: "Terms of Use",
          label: "Terms of Use",
          destination_url:
            "https://docs.google.com/document/d/1SuXHTQVprMGLbfzICaWVENChlDE4BC8c/",
        });
      },
    },
  ],

  copyright: "KERNELDAO",
};
